var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgNoimagePlaceholder = function SvgNoimagePlaceholder(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "6-Photo",
    id: "_6-Photo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43,0H5A5,5,0,0,0,0,5V43a5,5,0,0,0,5,5H43a5,5,0,0,0,5-5V5A5,5,0,0,0,43,0ZM5,46a3,3,0,0,1-3-3V40.46l16-16L39.59,46Zm41-3a3,3,0,0,1-3,3h-.59L28.55,32.14l7.59-7.59L46,34.41Zm0-11.41-9.16-9.16a1,1,0,0,0-1.41,0l-8.29,8.29-8.41-8.41a1,1,0,0,0-1.41,0L2,37.63V5A3,3,0,0,1,5,2H43a3,3,0,0,1,3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,7a6,6,0,1,0,6,6A6,6,0,0,0,25,7Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,25,17Z"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgNoimagePlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/noimage-placeholder.b5dc767b7c24a8a81aa40820d7e1ba6e.svg";